import { ThemeInterface } from "./";

export const darkTheme: ThemeInterface = {
    colors: {
        background1: 'hsl(219, 30%, 18%)',
        background2: 'hsl(217, 28%, 15%)',
        background3: '#181F2B', //mainBackground
        background4: 'hsl(216, 53%, 9%)',

        detail1: 'hsl(176, 68%, 64%)',
        detail2: 'hsl(198, 60%, 50%)',
        error: 'hsl(0, 100%, 63%)',

        text: 'hsl(0, 0%, 100%)'
    },
    fonts: {
        family: {
            raleway: `'Raleway', sans-serif`,
            openSans: `'Open Sans', sans-serif`,
        }
    },
}